<template>
  <button class="help fs-6" @click="start()">
    <i class="bi fs-5 bi-question-circle"></i>
    <span class="d-none d-sm-block">Help</span>
  </button>
  <VOnboardingWrapper ref="wrapper" :steps="steps" class="VOnboardingStep-wrapper tour-container">
    <template #default="{ previous, next, step, exit, isFirst, isLast, index }">
      <VOnboardingStep :step="index" :class="{ 'VOnboardingStep-center': step?.center }">
        <div class="tour-card">
          <div class="tour-card-head">
            <div class="card-title-action">
              <Typography v-if="step.content.title" transform="capitalize" size="1.15rem">
                {{ step.content.title }}
              </Typography>
              <v-btn size="small" @click="exit" icon variant="plain">
                <v-icon color="chsGray900">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-divider class="mt-0"></v-divider>
            <div class="tour-card-text" v-if="Array.isArray(step.content.description)">
              <component
                v-for="item in step.content.description"
                :key="item"
                :is="item.comp"
                :class="item.class"
                >{{ item.text }}</component
              >
            </div>
            <template v-if="typeof step.content.description === 'string'">
              <div
                class="tour-card-text"
                v-for="line in step.content.description.split('\n')"
                :key="line"
              >
                {{ line }}
              </div>
            </template>
          </div>
          <div class="tour-card-footer">
            <template v-if="isFirst">
              <v-btn size="small" @click="next" color="primary">
                {{ step.content.cta }}
              </v-btn>
            </template>
            <template v-else>
              <v-btn size="small" @click="previous" type="button" color="primary"> Back </v-btn>
              <v-btn size="small" @click="next" color="primary">
                {{ isLast ? "Finish" : "Next" }}
              </v-btn>
            </template>
          </div>
        </div>
      </VOnboardingStep>
    </template>
  </VOnboardingWrapper>
</template>

<script lang="tsx" setup>
import { computed, ref } from "vue";

import { VOnboardingWrapper, useVOnboarding, VOnboardingStep } from "v-onboarding";
import Typography from "@/components/typography.vue";
const wrapper = ref(null);
const { start } = useVOnboarding(wrapper);

const steps = computed(() => {
  return [
    {
      attachTo: { element: `.select-event` },
      content: {
        cta: "Next",
        title: "Events",
        description: `Click here to select the teacher/team event`
      }
    },
    {
      attachTo: { element: `#pills-schedule-tab` },
      content: {
        title: "Full Schedule",
        description: `View your full schedule`
      }
    },
    {
      attachTo: { element: `#pills-agenda-tab` },
      content: {
        title: "Agenda",
        description: `View your Schedule summary, excluding empty schedule`
      }
    },
    {
      attachTo: { element: `.print-btn` },
      content: {
        title: "Print",
        description: `Print the agenda to pdf`
      }
    },
    {
      attachTo: { element: `.email-btn` },
      content: {
        title: "Email",
        description: `Get an email with the schedule data`
      }
    },
    {
      attachTo: { element: `.export-btn` },
      content: {
        title: "Export",
        description: `Export the schedule data to a calendar compatible file`
      }
    }
  ] as const;
});
</script>

<style lang="scss" scoped>
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.tour-card {
  background-color: white;
  margin-top: 7px;
  margin-left: 7px;
  z-index: 9999 !important;
  min-width: 500px;
  border-radius: 10px !important;
  overflow: hidden;

  .tour-card-head {
    .card-title-action {
      display: flex;
      justify-content: space-between;
      padding: 7px 10px 0 15px;
      align-items: center;
    }
    .tour-card-text {
      padding: 0 5px;
      text-align: start;
      min-width: 400px;
    }
  }
  .tour-card-footer {
    padding: 0 5px 5px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 10px;
  }
}

.tour-container {
  :deep([data-popper-arrow]::before) {
    content: "";
    position: absolute;
    left: -6px;
    top: 4px;
    height: 0;
    width: 0;
    border-top: 7px solid white;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    transform: unset;
    background-color: transparent;
  }
}

.highlight-text {
  color: $primary;
}

.help {
  display: flex;
  align-items: center;
  gap: 7px;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  transition: background-color 0.2s linear;

  &:hover {
    background-color: rgba(0, 0, 0, 0.134);
  }
  &:active {
    background-color: rgba(0, 0, 0, 0.234);
  }
}
</style>
